import { cn } from "@/lib/utils";
import parse from "html-react-parser";

export default function Text({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <div
            className={cn(
                "prose prose-ul:flex prose-ul:flex-col prose-ul:gap-2 prose-li:my-1 text-md prose-a:text-brand-dark hover:prose-a:text-on-primary",
                className
            )}
        >
            {children}
        </div>
    );
}
